// Planificateur : répartir les créneaux proposés sur toute la fenêtre commune, et décrire un créneau
// pour chaque participant dans son heure locale.
import { label, placeOf, type Contact, type Profile } from './contact';
import { prettyDate, span } from './time';
import type { Slot } from './schedule';

/**
 * Choisit jusqu’à `n` créneaux répartis sur l’ensemble des candidats (début, milieu, fin),
 * sans chevauchement entre eux. La v1 collait les propositions au début de la plage.
 */
export function spreadSlots(candidates: Slot[], n = 4): Slot[] {
  if (!candidates.length || n <= 0) return [];
  const nonOverlapping: Slot[] = [];
  for (const s of candidates) {
    const last = nonOverlapping[nonOverlapping.length - 1];
    if (!last || s.start >= last.end) nonOverlapping.push(s);
  }
  if (nonOverlapping.length <= n) return nonOverlapping;
  const picked: Slot[] = [];
  const lastIndex = nonOverlapping.length - 1;
  for (let k = 0; k < n; k++) {
    const idx = Math.round((k / (n - 1)) * lastIndex);
    const s = nonOverlapping[idx]!;
    if (!picked.includes(s)) picked.push(s);
  }
  return picked;
}

/** Texte prêt à coller : le créneau chez moi, puis chez chaque participant, dans son heure locale. */
export function proposalText(slot: Slot, me: Profile): string {
  const lines = [
    'Proposition d’appel — ' + prettyDate(slot.start, me.tz, true),
    '',
    `Chez moi (${placeOf(me)}) : ${span(me.tz, slot)}`,
  ];
  for (const c of slot.people) {
    lines.push(`${label(c)}${c.org && c.name ? ' (' + c.name + ')' : ''} · ${placeOf(c)} : ${prettyDate(slot.start, c.tz)} ${span(c.tz, slot)}`);
  }
  lines.push('', 'Ce créneau vous convient-il ?');
  return lines.join('\n');
}

/** Résumé court des heures locales des participants : « ARTURA 12:30 · EREBUS 17:00 ». */
export function localTimesSummary(slot: Slot, timeOf: (tz: string, ms: number) => string): string {
  return slot.people.map((c: Contact) => `${label(c)} ${timeOf(c.tz, slot.start)}`).join(' · ');
}
